<reporting-dialog-report-xml-result></reporting-dialog-report-xml-result>
<reporting-dialog-planting-report-criteria></reporting-dialog-planting-report-criteria>
<reporting-dialog-volunteer-report-xml-result></reporting-dialog-volunteer-report-xml-result>
<reporting-dialog-volunteer-report-criteria></reporting-dialog-volunteer-report-criteria>
<reporting-dialog-not-planted-report-criteria></reporting-dialog-not-planted-report-criteria>
<reporting-dialog-final-field-test-report-criteria></reporting-dialog-final-field-test-report-criteria>
<reporting-dialog-regulated-regcomp-report-criteria></reporting-dialog-regulated-regcomp-report-criteria>
<reporting-dialog-stewarded-regcomp-report-criteria></reporting-dialog-stewarded-regcomp-report-criteria>
